import { render, staticRenderFns } from "./RecruitingFirm.vue?vue&type=template&id=6048f268&scoped=true&"
import script from "./RecruitingFirm.vue?vue&type=script&lang=js&"
export * from "./RecruitingFirm.vue?vue&type=script&lang=js&"
import style0 from "./RecruitingFirm.vue?vue&type=style&index=0&id=6048f268&scoped=true&lang=scss&"
import style1 from "./RecruitingFirm.vue?vue&type=style&index=1&id=6048f268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6048f268",
  null
  
)

export default component.exports